import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MailGroupActions, MailGroupActionTypes } from '../actions/mail-group.action';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: MailGroupActions
): State {
  switch (action.type) {

    case MailGroupActionTypes.GetMailGroupList: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case MailGroupActionTypes.UpsertMailGroupList: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case MailGroupActionTypes.GetMailGroupListFail: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const getMailGroupListState = (state: State) => state;
